import { createSharedComposable } from "@vueuse/core";

const _useDashboard = () => {
  const isHelpSlideoverOpen = ref(false);
  const isNotificationsSlideoverOpen = ref(false);
  const familyGroupsStore = useGroupStore();
  const toast = useToast();

  // Only initialize shortcuts and watchers on client side
  onMounted(() => {
    const route = useRoute();
    const router = useRouter();

    // Base navigation shortcuts
    const baseShortcuts: Record<string, () => void> = {
      "g-h": () => router.push("/user"),
      "g-i": () => router.push("/inbox"),
      "g-t": () => router.push("/tasks"),
      "g-s": () => router.push("/settings"),
      "g-o": () => router.push("/observations"),
      "g-r": () => router.push("/residents"),
      "g-c": () => router.push("/children"),
      "?": () => (isHelpSlideoverOpen.value = true),
      n: () => (isNotificationsSlideoverOpen.value = true),
    };

    // Group switching shortcuts (G+1 through G+8)
    const groupKeys = ["1", "2", "3", "4", "5", "6", "7", "8"];
    groupKeys.forEach((key, index) => {
      baseShortcuts[`g-${key}`] = () => {
        try {
          const group = familyGroupsStore.userGroups[index];
          if (!group) {
            toast.add({
              title: "Group not found",
              description: `No group at position ${index + 1}`,
              color: "warning",
            });
            return;
          }
          familyGroupsStore.setCurrentSelectedGroup(group);
        } catch (error) {
          console.error("Failed to switch group:", error);
          toast.add({
            title: "Failed to switch group",
            description: "An error occurred while switching groups",
            color: "error",
          });
        }
      };
    });

    defineShortcuts(baseShortcuts);

    watch(
      () => route.fullPath,
      () => {
        isHelpSlideoverOpen.value = false;
        isNotificationsSlideoverOpen.value = false;
      },
    );
  });

  return {
    isHelpSlideoverOpen,
    isNotificationsSlideoverOpen,
  };
};

export const useDashboard = createSharedComposable(_useDashboard);
